import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { activatePortal } from '../../redux/reducers/portalAuthSlice';
import { LuCircleCheck, LuCircleX } from "react-icons/lu";

const PortalActivate = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, activationData } = useSelector((state) => state.portalAuth);

    useEffect(() => {
        if (token) {
            dispatch(activatePortal(token));
        }
    }, [token, dispatch]);

    return (
        <div className="bg-light min-vh-100 d-flex align-items-center">
            <Container>
                <Card className="border-0 shadow-sm rounded-4 mx-auto text-center" style={{ maxWidth: '500px' }}>
                    <Card.Body className="p-5">
                        {loading ? (
                            <div className="py-4">
                                <Spinner animation="border" variant="primary" style={{ color: "#28B0C4" }} />
                                <p className="mt-3 text-muted">Activating your portal access...</p>
                            </div>
                        ) : error ? (
                            <div className="py-2">
                                <LuCircleX size={64} className="text-danger mb-3" />
                                <h3 className="fw-bold">Activation Failed</h3>
                                <p className="text-muted mb-4">{error}</p>
                                <Button 
                                    variant="outline-secondary" 
                                    className="rounded-3 px-4"
                                    onClick={() => navigate('/customer-side/login')}
                                >
                                    Go to Login
                                </Button>
                            </div>
                        ) : (
                            <div className="py-2">
                                <LuCircleCheck size={64} className="text-success mb-3" />
                                <h3 className="fw-bold">Welcome, {activationData?.name}!</h3>
                                <p className="text-muted mb-4">
                                    Your portal account with <span className="text-dark fw-semibold">{activationData?.businessName || 'the business'}</span> has been successfully activated.
                                </p>
                                <Button 
                                    className="w-100 rounded-3 py-2 fw-bold text-white border-0"
                                    style={{ background: "#28B0C4" }}
                                    onClick={() => navigate('/customer-side/login')}
                                >
                                    Access Your Portal
                                </Button>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default PortalActivate;
